import styled from '@emotion/styled';

import { Icon, tokens } from '@hotjar/hotsauce';

export const DetailLabelIcon = styled(Icon)`
  color: ${tokens.color.cobalt_800};
  height: 12px;
  margin: 0 0 ${tokens.spacer.x0} ${tokens.spacer.x1};
  opacity: 0;
  visibility: hidden;
  width: 12px;
`;
